import { useCallback, useEffect, useRef, useState } from "react";
import { CLINICAL_STREAM_STATES } from "../deviceWebSocket/deviceMessageProtocol";
import { KvsViewerSession } from "./KvsViewerSession";

const initialStatus = {
  state: CLINICAL_STREAM_STATES.STOPPED,
  streamSessionId: null,
  deviceId: null,
};

export const useClinicalDeviceViewer = ({ kioskDeviceId, organizationId }) => {
  const [status, setStatus] = useState(initialStatus);
  const [remoteStream, setRemoteStream] = useState(null);
  const sessionRef = useRef(null);

  if (!sessionRef.current) {
    sessionRef.current = new KvsViewerSession({
      onStateChange: setStatus,
      onRemoteStream: setRemoteStream,
    });
  }

  const start = useCallback(({ streamSessionId, deviceId }) => (
    sessionRef.current?.start({
      kioskDeviceId,
      organizationId,
      streamSessionId,
      clinicalDeviceId: deviceId,
    }) ?? false
  ), [kioskDeviceId, organizationId]);

  const stop = useCallback(() => {
    sessionRef.current?.stop();
  }, []);

  useEffect(() => () => {
    sessionRef.current?.dispose();
  }, []);

  return {
    status,
    remoteStream,
    start,
    stop,
  };
};
